import { InjectionToken } from '@angular/core';

/**
 * Base URL for the User Management API (Employee endpoints).
 *
 * The consuming application must provide this token:
 * { provide: UM_API_BASE_URL, useValue: environment.apiUrl.userManagement }
 */
export const UM_API_BASE_URL = new InjectionToken<string>('UM_API_BASE_URL');
